import ColumnTypes from '@/utils/ColumnTypes';

const nickName = {
	key: 'nickname',
	label: '用户名称',
	type: ColumnTypes.TextCell,
	minWidth: '120',
	headerAlign: 'left',
	maxShowLength: 9,
};

const mobile = {
	key: 'mobile',
	label: '手机号',
	type: ColumnTypes.TextCell,
	minWidth: '140',
	headerAlign: 'left',
};
const wechatInfo = {
	label: '绑定微信',
	type: () => import('@/views/teamManage/accountManage/components/tableCells/deliveryCell.vue'),
	minWidth: '180',
	headerAlign: 'left',
	maxShowLength: 10,
};
const deptDesc = {
	key: 'deptDesc',
	label: '部门',
	type: ColumnTypes.TextCell,
	minWidth: '180',
	headerAlign: 'left',
	maxShowLength: 10,
};
const operations = {
	key: 'operations',
	label: '操作',
	type: ColumnTypes.ButtonsCell,
	minWidth: '120',
	headerAlign: 'left',
};

export const columns = [nickName, mobile, wechatInfo, deptDesc, operations];
export const superColumns = [nickName, mobile, wechatInfo, deptDesc];
